var _a;
import { StorageBucket, } from './file-storage.model';
// This allows to configure the myriad of backend file storage services we have
// on a per-bucket basis, the goal being the long term all the buckets should
// use the
export var configs = (_a = {},
    _a[StorageBucket.FL_DRIVE] = function (ref) { return ({
        endpoint: "files/0.1/files/" + ref.id,
        fileParam: 'files[]',
        downloadURLEndpoint: "files/0.1/files/" + ref.id + "/download?as_json=true",
        downloadURL: function (result) { return result.download_url; },
    }); },
    _a[StorageBucket.LEGACY_PROJECT_FILES] = function (ref) { return ({
        endpoint: 'projects/upload.php',
        isGaf: true,
        fileParam: 'files[]',
        DEPRECATED_extraParams: function (metadata) {
            if (!metadata.customMetadata || !metadata.customMetadata.projectId) {
                throw new Error('Missing projectId in custom metadata');
            }
            return {
                'attachments[]': metadata.name,
                project_id: metadata.customMetadata.projectId,
                bid_id: metadata.customMetadata.bidId,
            };
        },
    }); },
    _a[StorageBucket.LEGACY_PROJECT_ATTACHEMENTS] = function () { return ({
        endpoint: 'projects/uploadTemporaryFile.php',
        isGaf: true,
        fileParam: 'files[]',
        DEPREACTED_DO_NOT_USE_backendId: function (result) { return result.fileIds[0]; },
    }); },
    _a[StorageBucket.PROFILE_PICTURES] = function (ref) { return ({
        endpoint: 'users/0.1/self/profile_picture/',
        fileParam: 'filedata',
        downloadURL: function (result) { return result.avatar_url; },
        DEPRECATED_extraParams: function (metadata) {
            if (!metadata.customMetadata ||
                !metadata.customMetadata.x ||
                !metadata.customMetadata.y ||
                !metadata.customMetadata.cropW ||
                !metadata.customMetadata.cropH) {
                throw new Error('missing x, y, cropW, or cropH custom metadata');
            }
            return {
                x: metadata.customMetadata.x,
                y: metadata.customMetadata.y,
                cropW: metadata.customMetadata.cropW,
                cropH: metadata.customMetadata.cropH,
            };
        },
    }); },
    _a[StorageBucket.PROFILE_COVER_IMAGES] = function (ref) { return ({
        endpoint: 'users/0.1/self/cover_image/',
        fileParam: 'filedata',
        DEPRECATED_extraParams: function (metadata) {
            if (!metadata.customMetadata ||
                !metadata.customMetadata.x ||
                !metadata.customMetadata.y ||
                !metadata.customMetadata.crop_width ||
                !metadata.customMetadata.crop_height) {
                throw new Error('missing x, y, crop_width, or crop_height custom metadata');
            }
            return {
                x: metadata.customMetadata.x,
                y: metadata.customMetadata.y,
                crop_width: metadata.customMetadata.crop_width,
                crop_height: metadata.customMetadata.crop_height,
            };
        },
    }); },
    _a[StorageBucket.MESSAGING_ATTACHEMENTS] = function (ref) { return ({
        endpoint: 'this_is_not_used',
        DEPRECATED_funkyChangingEndpoint: function (metadata) {
            if (!metadata.customMetadata || !metadata.customMetadata.threadId) {
                throw new Error('missing threadId custom metadata');
            }
            return "messages/0.1/threads/" + metadata.customMetadata.threadId + "/messages/";
        },
        fileParam: 'files[]',
        DEPRECATED_extraParams: function (metadata) {
            if (!metadata.customMetadata ||
                !metadata.customMetadata.threadId ||
                !metadata.customMetadata.clientMessageId) {
                throw new Error('missing threadId or clientMessageId custom metadata');
            }
            return {
                thread_id: metadata.customMetadata.threadId,
                client_message_id: metadata.customMetadata.clientMessageId,
            };
        },
    }); },
    _a[StorageBucket.PORTFOLIO_ITEMS] = function () { return ({
        endpoint: "showcase/uploadFile.php",
        fileParam: 'files[]',
        isGaf: true,
        DEPREACTED_DO_NOT_USE_backendId: function (result) { return result.id; },
    }); },
    _a);
